module.exports = __webpack_public_path__ + "assets/img/VentureCrowd-Pillar-Page-Resource.7a5e1864.webp";